import { IVehicle } from 'components/SearchBlock/CarSearch/CarSearchBlock';

export const SET_SELECTED_VEHICLE = 'setSelectedVehicle';
export const SELECTED_VEHICLE_STORAGE_KEY = 'selectedVehicle';

// Read once at store creation so the remembered car is in state synchronously on first render
// (SearchBlock captures it immediately, no async rehydrate that could trigger a stray redirect).
const readPersistedVehicle = (): IVehicle | undefined => {
    try {
        const stored = sessionStorage.getItem(SELECTED_VEHICLE_STORAGE_KEY);
        return stored ? JSON.parse(stored) : undefined;
    } catch (e) {
        return undefined;
    }
};

const selectedVehicleReducer = (
    state: {
        selectedVehicle?: IVehicle;
    } = {
        selectedVehicle: readPersistedVehicle(),
    },
    action: {
        type: string;
        payload: any;
    },
) => {
    const handleSet = (payload?: IVehicle) => {
        return {
            ...state,
            selectedVehicle: payload,
        };
    };

    switch (action.type) {
        case SET_SELECTED_VEHICLE: {
            return handleSet(action.payload);
        }

        default: {
            return state;
        }
    }
};

export default selectedVehicleReducer;
